import { NgModule } from '@angular/core';
import { ItemConflictService } from './item-conflict.service';
import { ItemDependencyService } from './item-dependency.service';
import { LineItemCacheService } from './line-item-cache.service';
import { PackageContentsService } from './package-contents.service';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [LineItemCacheService, ItemConflictService, ItemDependencyService, PackageContentsService],
})
export class ServicesModule {}
